import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]华财100Tab下基金信息列表
 */
export function getFundInfoListUsingPOST(
  req: HFinance100Dto | void,
  config?: RequestConfig
): Promise<ApiResultListHFinance100Vo> {
  return resource.postNoAuth('/hc100/fundInfoList', req, config);
}

/**
 * [No Auth] 查询基金经理信息(选基工具使用)
 */
export function getAllFundManagerUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListFundManagerInfoVo> {
  return resource.postNoAuth('/hc100/getAllFundManager', req, config);
}

/**
 * [No Auth]获取所有基金信息(选基工具使用)
 */
export function getAllProdUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultProdInfoVo> {
  return resource.postNoAuth('/hc100/getAllProd', req, config);
}

/**
 * [No Auth] 获取基金收益率(选基工具使用)
 */
export function getFundIncomeRateUsingPOST(
  req: SecuCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundIncomeVo> {
  return resource.postNoAuth('/hc100/getFundIncomeRate', req, config);
}

/**
 * [No Auth]华财100Tab列表
 */
export function getTabInfosUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListTabInfo4HF100> {
  return resource.postNoAuth('/hc100/tabInfo', req, config);
}

/**
 * [No Auth]华财100首页列表
 */
export function getTabListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultModelInfo4HC100> {
  return resource.postNoAuth('/hc100/tabList', req, config);
}
